module.exports = __webpack_public_path__ + "static/media/text-2.60ab1385.png";